import React from "react";
import Table from "react-bootstrap/Table";
import { useEffect, useContext } from "react";
import axios from ".././axios-interceptor";
import { useState } from "react";
import NavBarMain from "./NavBarMain";
import { base_url, STATUS_APPROVED, STATUS_IN_PROGRESS, STATUS_NEW, STATUS_PROCESSED, STATUS_REJECTED, STATUS_CLOSED } from "./../utilities";
import "react-toastify/dist/ReactToastify.css";
import ApplyNewLoan from "./ApplyNewLoan";
import EachLoanBreakUp from "./EachLoanBreakUp";
import SideNavBar from "./SideNavBar";
import TableData from "../AdminFlow/TableData";
import jsPDF from 'jspdf';
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import Cookies from 'js-cookie';


const MyLoans = (props) => {
  
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Business")) {
      navigate("/");
    }
  }, []);

  let ltwo = props.loading;
  const [modalShow, setModalShow] = React.useState(false);
  const [loandata, setLoanData] = useState([]);
  const [loandatafilter, setLoandataFilter] = useState([]);
  const [loading, setLoading] = useState(true)
  const [firstValue, setFirstValue] = useState([])
  const [secondValue, setSecondValue] = useState([])
  const [thirdValue, setThirdValue] = useState([])
  const [fourthValue, setFourthValue] = useState([])
  const [fifthValue, setFifthValue] = useState([])

let countlen = (loandatafilter.length) 

function generatePDF() {
  // Get the HTML table element
  const table = document.getElementById('my-table');

  // Initialize jsPDF
  const doc = new jsPDF();

  // Convert the table to a PDF document
  doc.autoTable({
    html: table,
    startY: 10,
    margin: { horizontal: 10 },
  });

  // Save the PDF document
  doc.save('loans_list.pdf');
}
 
const getLoanData=(data)=>{
  setLoanData(data)
  setFirstValue(data)
  setSecondValue(data)
  setThirdValue(data)
  setFourthValue(data)
  setFifthValue(data)
}
const getLoanDataFilter=(data)=>{
  setLoandataFilter(data)
  setFirstValue(data)
  setSecondValue(data)
  setThirdValue(data)
  setFourthValue(data)
  setFifthValue(data)

}
const getLoading=(data)=>{
  setLoading(data)
}
const [businessdataUser,setBusinessdataUser] = useState()
const businessName = businessdataUser?.business_name

  useEffect(() => {
    axios
      .post(base_url + "get/loan-type/master", {})
      .then((res) => {
        // setLoantypeMaster(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .post(base_url + "loan-trx/get_loan_trx_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        const data = res.data.data;

        if (data) {
          setLoanData(data);
          setLoandataFilter(data);
        } else {
          setLoanData("No Data Found");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(base_url + "documents-type/get_document_types", {})
      .then((res) => {
        let doctypes = res.data.data;
        let x = [];
        doctypes.LOAN.forEach((element) => {
          x.push({ doc_type: element, is_upload: false });
        });
        // setDownload(x);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(base_url + "business-master/get_business_data_user", {
        user_id: Cookies.get("business_id"),
      })
      .then((res) => {
        setBusinessdataUser(res.data.data[0])
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);
  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')
  const [fifthFilterValue, setFifthFilterValue] = useState('')
  const [sixthFilterValue, setSixthFilterValue] = useState('')
  

const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDefaultValue(false)

    if (name === "loanRefNo" && initialValue ==='' && thirdFilterValue ==='' && fourthFilterValue ==='' && fifthFilterValue ==='' && sixthFilterValue ==='') {
      setSecondFilterValue('loanRefNo')
      let f = secondValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value === "All") {
      setSecondFilterValue('')

          return item;
        }
      });

      setLoandataFilter(f);
      setFirstValue(f)
  setThirdValue(f)
  setFourthValue(f)
  setFifthValue(f)

    }
    if (name === "loanRefNo" &&  thirdFilterValue!=='') {
      let f = secondValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });

      setLoandataFilter(f);
      setFirstValue(f)
  setFourthValue(f)
  setFifthValue(f)

    }

    if (name === "loantype" && initialValue ==='' && secondFilterValue ==='' && fourthFilterValue ==='' && fifthFilterValue ==='' && sixthFilterValue ==='') {
  setThirdFilterValue('loantype')
      let fltype = thirdValue.filter((item) => {
        if (value === item.loan_type_name) {
          return item;
        }
        if (value === "All") {
  setThirdFilterValue('')

          return item;
        }
      });

      setLoandataFilter(fltype);
      setFirstValue(fltype)
  setSecondValue(fltype)
  setFourthValue(fltype)
  setFifthValue(fltype)

    }
    if (name === "loantype" &&  fourthFilterValue !=='' ) {
      let fltype = thirdValue.filter((item) => {
        if (value === item.loan_type_name) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });

      setLoandataFilter(fltype);
      setFirstValue(fltype)
  setSecondValue(fltype)
  setFifthValue(fltype)

    }

    if(name === 'totaloan' ){

      let startRange = value.split('-')[0];
     let endRange = value.split('-')[1];
      let f = fourthValue.filter((item) => {
let loanamount = Number(item.loan_amount)
let initialAmount = Number(startRange)
let finalAmount = Number(endRange)


        if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
           return item;
        } 

        if (value === "All") {
          return item;
        }
      });
      setLoandataFilter(f);
      setFirstValue(f)
      setSecondValue(f)
      setThirdValue(f)
      setFifthValue(f)
    }
    
    if (name === "benrate" && initialValue ==='' && secondFilterValue ==='' && fourthFilterValue ==='' && thirdFilterValue ==='' && sixthFilterValue ==='') {
      setFifthFilterValue('benrate')
      let NumberValue = Number(value);
      let f = fifthValue.filter((item) => {
    
        if (NumberValue === Number(item.bennefin_roi)) {
          return item;
        }
        if (value === "All") {
      setFifthFilterValue('')

          return item;
        }
      });
      setLoandataFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "benrate" && thirdFilterValue !=='' ) {
      let NumberValue = Number(value);
      let f = fifthValue.filter((item) => {
    
        if (NumberValue === Number(item.bennefin_roi)) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setLoandataFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setFourthValue(f);
    }

    if (name === "loan_tenure" && fifthFilterValue ==='' && secondFilterValue ==='' && fourthFilterValue ==='' && thirdFilterValue ==='' && sixthFilterValue ==='') {
      setInitialValue('loan_tenure')
      let y = value.split(" ");
      // setTenure(y[0]);
      let tenurevalue = Number(value.split(" ")[0])
      
      let fLoanTenure = firstValue.filter((item) => {
        if (tenurevalue === item.loan_tenure) {
          return item;
        }
        if (value === "All") {
      setInitialValue('')

          return item;
        }
      });
      setLoandataFilter(fLoanTenure);
  setSecondValue(fLoanTenure)
  setThirdValue(fLoanTenure)
  setFourthValue(fLoanTenure)
  setFifthValue(fLoanTenure)

    }
    if (name === "loan_tenure"  && fourthFilterValue !=='') {
      let y = value.split(" ");
      let tenurevalue = Number(value.split(" ")[0])
      
      let fLoanTenure = firstValue.filter((item) => {
        if (tenurevalue === item.loan_tenure) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setLoandataFilter(fLoanTenure);
  setSecondValue(fLoanTenure)
  setThirdValue(fLoanTenure)
  setFifthValue(fLoanTenure)

    }
    
    if (name === "status" && secondFilterValue ==='' && fifthFilterValue ==='' && thirdFilterValue ==='' && sixthFilterValue ==='') {
      setFourthFilterValue("status")
      let flstatus = fourthValue.filter((item) => {
        if (value === 'New'){
          if(STATUS_NEW === item.status){
            return item;}
          }
          if (value === 'Processed'){
            if(STATUS_PROCESSED === item.status){
              return item; } 
              }
              if (value === 'In Progress'){
                if(STATUS_IN_PROGRESS === item.status){
                  return item; } 
                  }
                  if (value === 'Approved'){
                    if(STATUS_APPROVED === item.status){
                      return item; } 
                      }
                      if (value === 'Rejected'){
                        if(STATUS_REJECTED === item.status){
                          return item; } 
                          }
                          

        
         if (value === "All") {
      setFourthFilterValue("")

          return item;
        }
      });

      setLoandataFilter(flstatus);
      setFirstValue(flstatus)
      setSecondValue(flstatus)
      setThirdValue(flstatus)
      setFifthValue(flstatus)
    }
    if (name === "status" && initialValue !=='' ) {
      let flstatus = fourthValue.filter((item) => {
        if (value === 'New'){
          if(STATUS_NEW === item.status){
            return item;}
          }
          if (value === 'Processed'){
            if(STATUS_PROCESSED === item.status){
              return item; } 
              }
              if (value === 'In Progress'){
                if(STATUS_IN_PROGRESS === item.status){
                  return item; } 
                  }
                  if (value === 'Approved'){
                    if(STATUS_APPROVED === item.status){
                      return item; } 
                      }
                      if (value === 'Rejected'){
                        if(STATUS_REJECTED === item.status){
                          return item; } 
                          }
                          

        
         if (value === "All") {
          return item;
        }
      });

      setLoandataFilter(flstatus);
      setSecondValue(flstatus)
      setThirdValue(flstatus)
      setFifthValue(flstatus)
      
    }

  };
  
  function exportToExcel() {
    let sample_data_array = [];
    loandatafilter.forEach((elem) => {
      if(elem.status===STATUS_NEW){
        elem.status = "New"
      }
      if(elem.status===STATUS_IN_PROGRESS){
        elem.status = "Inprogress"
      }
      if(elem.status===STATUS_APPROVED){
        elem.status = "Approved"
      }
      if(elem.status===STATUS_REJECTED){
        elem.status = "Rejected"
      }
      if(elem.status===STATUS_PROCESSED){
        elem.status = "Processed"
      }
      if(elem.status===STATUS_CLOSED){
        elem.status = "Closed"
      }
      
      let xl_object = {
        "Loan Ref No": elem.loan_reference_number,
        "Loan Type": elem.loan_type_name,
        "Loan Amount": elem.loan_amount === undefined ? '-' : elem.admin_request_loan_currency+" "+elem.loan_amount,
        "Monthly Interest Rate(%)": elem.bennefin_roi,
        "Total Repaid": elem.total_repaid === undefined ? '-' : elem.admin_request_loan_currency+" "+elem.total_repaid,
        "Tenure": elem.loan_tenure === 1 ? elem.loan_tenure +" Month" : elem.loan_tenure + " Months",
        "Status": elem.status,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = businessdataUser?.business_name + "_My_Loans_Data.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }


  const [hidecontent, setHideContent] = useState("d-block");
  const [shownextcontent, setShowNextContent] = useState("d-none");
  const [loanrefno, setLoanRefNo] = useState([]);

  const handleHideContent = (props) => {
    setHideContent("d-none");
    setShowNextContent("d-block");
    setLoanRefNo(props.loan_reference_number);
  };
 
  const [defaultvalue, setDefaultValue] = useState()

const clearFilters=()=>{
  setLoandataFilter(loandata)
  setDefaultValue(true)
  setFirstValue(loandata)
  setSecondValue(loandata)
  setThirdValue(loandata)
  setFourthValue(loandata)
  setFifthValue(loandata)
  setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
    setFourthFilterValue('')
    setFifthFilterValue('')
    setSixthFilterValue('')
}
const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
const columns = [
  {title:"Loan Ref No",field:"loan_reference_number"},
  {title:"Loan Type",field:"loan_type_name"},
  {title:"Loan Amount",field:"loan_amount",currency : "admin_request_loan_currency"},
  {title:"Monthly Interest Rate",field:"bennefin_roi"},
  {title:"Total Repaid",field:"total_repaid",currency : "admin_request_loan_currency"},
  {title:"Tenure",field:"loan_tenure"},
  {title:"Status", field:"status"},
  {title:"Details",field:"loan_image", image:"./images/icons/double_arrow.svg",datatopass:"loan_reference_number"},
];
const handleSort = (column) => {
  let direction = "asc";
  if (sortOrder.column === column && sortOrder.direction === "asc") {
    direction = "desc";
  }
  setSortOrder({ column, direction });

  const sortedData = [...loandatafilter].sort((a, b) => {
    const columnA = column === 'loan_amount' ? parseInt(a[column]) : a[column];
    const columnB = column === 'loan_amount' ? parseInt(b[column]) : b[column];
    if (typeof columnA === "string" && typeof columnB === "string") {
      return direction === "asc" ? columnA.localeCompare(columnB) : columnB.localeCompare(columnA);
    } else if (typeof columnA === "number" && typeof columnB === "number") {
      return direction === "asc" ? columnA - columnB : columnB - columnA;
    } else {
      return 0;
    }
  });
  setLoandataFilter(sortedData);
};
const uniqueLoanRefNo = [...new Set(secondValue.map(refNo => refNo.loan_reference_number))];
const uniqueLoanTypes = [...new Set(thirdValue.map(ltype => ltype.loan_type_name))];
const uniqueTenure = [...new Set(firstValue.map(tenure => tenure.loan_tenure))];
const uniqueStatuses = [...new Set(fourthValue.map(status => status.status))];
const uniqueRate = [...new Set(fifthValue.map(rate => rate.bennefin_roi))];






  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <SideNavBar />
      <main style={{ width: "100%" }}>
        <NavBarMain businessname={businessdataUser?.business_name} />

        <div className={` px-5 pt-xxl-4 pt-3 ${hidecontent} `}>
          <div className="row d-flex justify-content-between justify-content-lg-start align-items-center  ">
            <div className="col-lg-2 d-flex align-items-center ">
              <h1 className=""> My Loans </h1>
            </div>

            <div className="col-lg d-flex justify-content-lg-end justify-content-between mt-2 mt-lg-0 mb-2 mb-lg-0 mb-lg-2">
              <div className="d-flex me-3 align-items-center "></div>
              <div className="d-flex">
                <button
                  className="btn blue_btn"
                  onClick={() => setModalShow(true)}
                >
                  Apply New Loan
                </button>
                <button onClick={exportToExcel} className="btn gray_btn ms-3">
                  Download Statement
                </button>
              </div>
            </div>
          </div>
          <ApplyNewLoan
            getLoading={getLoading}
            getloandata={getLoanData}
            getloandatafilter={getLoanDataFilter}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />

          <div className=" p-0 ">
            <div className="row mb-3 gap-2 row-cols-3 ">
              <div className="col-md">
                <label htmlFor="country" className="form-label">
                  <p>Loan Ref No.</p>
                </label>
                <select
                  id="loanRefNo"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loanRefNo"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>

                  {uniqueLoanRefNo.map((refNo) => {
                    return <option key={refNo}>{refNo}</option>;
                  })}
                </select>
              </div>
              <div className="col-lg col-sm">
                <label htmlFor="country" className="form-label">
                  <p>Loan Type</p>
                </label>
                <select
                  id="loantype"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loantype"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueLoanTypes.map((loantype, id) => {
                    return <option key={id}>{loantype}</option>;
                  })}
                </select>
              </div>

              <div className="col-lg col-sm ">
                <label htmlFor="totaloan" className="form-label">
                  <p>Loan Amount</p>
                </label>
                <select
                  id="totaloan"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="totaloan"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  <option value="1000-5000">1000 - 5000</option>
                  <option value="5001-10000">5001 - 10000</option>
                  <option value="10001-50000">10001 - 50000</option>
                  <option value="50001-100000">50001 - 100000</option>
                  <option value="100001-500000">100001 - 500000</option>
                  <option value="500001-1000000">500001 - 1000000</option>
                </select>
              </div>
              <div className="col-lg col-sm">
                <label htmlFor="benrate" className="form-label">
                  <p>Rate</p>
                </label>
                <select
                  id="benrate"
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="benrate"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueRate.map((rate, id) => {
                    return (
                      <option key={id}>
                        {rate !== "" || rate !== undefined || rate !== null
                          ? rate
                          : "-"}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-lg col-sm ">
                <label htmlFor="country" className="form-label">
                  <p>Tenure Period</p>
                </label>
                <select
                  id="loan_tenure"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loan_tenure"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueTenure.map((tenure, id) => {
                    return (
                      <option key={id}>
                        {tenure === 1
                          ? tenure + " Month"
                          : tenure >= 2
                          ? tenure + " Months"
                          : ""}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-lg col-sm">
                <label htmlFor="country" className="form-label">
                  <p>Status</p>
                </label>
                <select
                  id="status"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="status"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueStatuses.map((status, index) => {
                    return (
                      <option key={index}>
                        {status === STATUS_NEW
                          ? "New"
                          : status === STATUS_IN_PROGRESS
                          ? "In Progress"
                          : status === STATUS_APPROVED
                          ? "Approved"
                          : status === STATUS_REJECTED
                          ? "Rejected"
                          : status === STATUS_PROCESSED
                          ? "Processed"
                          : status === STATUS_CLOSED
                          ? "Closed"
                          : "-"}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2 gap-3 ">
              <button className="blue_btn" onClick={clearFilters}>
                Clear All Filters
              </button>
              <span className=" count_of_records_ML ">
                <span>No.of Records : {countlen}</span>
              </span>
            </div>
            <div className="row">
              <div className="col mt-1 my_loan_table">
                <Table id="my-table" striped  className="">
                  <TableData
                    handleSort={handleSort}
                    ltwo={ltwo}
                    loading={loading}
                    data={loandatafilter}
                    columns={columns}
                    onImageClick={handleHideContent}
                  />
                </Table>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className={`${shownextcontent} `}>
            <EachLoanBreakUp
              hide={() => setHideContent("d-block")}
              showcontent={() => setShowNextContent("d-none")}
              business_name={businessName}
              loandata={loandata}
              loanrefno={loanrefno}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default MyLoans;
